export const isReadyCartSelectUtil = ({
  isLoaded,
  hasCartInfo,
  itemIdToSummary
}) => {
  return (
    !!isLoaded &&
    !!hasCartInfo &&
    !!itemIdToSummary
  )
}
